/**
 * Kopinas: intercepts every "Añadir al carrito" submit on the storefront and
 * requires the shopper to name their business + city before the item is
 * actually added. Those two values are attached to the cart line as
 * `properties[Nombre del negocio]` / `properties[Ciudad]` so Óscar can look
 * the business up on Google Maps and program the NFC plaque before shipping.
 */
if (!customElements.get('kopinas-business-popup')) {
  customElements.define(
    'kopinas-business-popup',
    class KopinasBusinessPopup extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('.kopinas-popup__dialog');
        this.form = this.querySelector('[data-kopinas-popup-form]');
        this.nameInput = this.querySelector('#KopinasBusinessName');
        this.cityInput = this.querySelector('#KopinasBusinessCity');
        this.errorMessage = this.querySelector('[data-kopinas-popup-error]');
        this.pendingForm = null;
        this.pendingSubmitter = null;
        this.openedBy = null;

        this.querySelectorAll('[data-kopinas-popup-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        this.form.addEventListener('submit', this.onConfirm.bind(this));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
      }

      open(originalForm, submitter) {
        this.pendingForm = originalForm;
        this.pendingSubmitter = submitter || null;
        this.openedBy = submitter || document.activeElement;
        this.errorMessage.hidden = true;

        this.hidden = false;
        // Force layout before adding the animation class so the transition runs.
        this.offsetHeight;
        this.classList.add('is-open');

        window.trapFocus(this.dialog, this.nameInput);
      }

      close() {
        if (this.hidden) return;
        this.classList.remove('is-open');
        window.removeTrapFocus(this.openedBy);
        this.pendingForm = null;
        this.pendingSubmitter = null;

        const dialog = this.dialog;
        const onTransitionEnd = () => {
          this.hidden = true;
          dialog.removeEventListener('transitionend', onTransitionEnd);
        };
        dialog.addEventListener('transitionend', onTransitionEnd);
      }

      onConfirm(event) {
        event.preventDefault();

        const businessName = this.nameInput.value.trim();
        const businessCity = this.cityInput.value.trim();

        if (!businessName || !businessCity) {
          this.errorMessage.hidden = false;
          (businessName ? this.cityInput : this.nameInput).focus();
          return;
        }

        const targetForm = this.pendingForm;
        const submitter = this.pendingSubmitter;
        if (!targetForm) {
          this.close();
          return;
        }

        this.setLineItemProperty(targetForm, 'Nombre del negocio', businessName);
        this.setLineItemProperty(targetForm, 'Ciudad', businessCity);

        this.classList.remove('is-open');
        window.removeTrapFocus();
        this.hidden = true;
        this.pendingForm = null;
        this.pendingSubmitter = null;

        targetForm.dataset.kopinasBypass = 'true';
        if (typeof targetForm.requestSubmit === 'function') {
          targetForm.requestSubmit(submitter || undefined);
        } else {
          targetForm.submit();
        }
      }

      setLineItemProperty(form, propertyName, value) {
        const inputName = `properties[${propertyName}]`;
        let input = form.querySelector(`input[name="${CSS.escape(inputName)}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = inputName;
          form.appendChild(input);
        }
        input.value = value;
      }
    }
  );
}

(function () {
  const popupTag = 'kopinas-business-popup';

  function getPopup() {
    return document.querySelector(popupTag);
  }

  // Capture phase runs before the form's own submit handler (product-form.js),
  // so we can block the real add-to-cart until the popup is confirmed.
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.type !== 'add-to-cart-form') return;

      if (form.dataset.kopinasBypass === 'true') {
        delete form.dataset.kopinasBypass;
        return;
      }

      const popup = getPopup();
      if (!popup) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      popup.open(form, event.submitter);
    },
    true
  );
})();
